import type { AuthorizationStatus } from '../../services/api';

export const AUTHORIZATION_STATUS_OPTIONS: {
  value: AuthorizationStatus;
  label: string;
}[] = [
  { value: 'NOT_STARTED', label: 'Not Started' },
  { value: 'PENDING', label: 'Pending' },
  { value: 'MISSING_INFORMATION', label: 'Missing Information' },
  { value: 'APPROVED', label: 'Approved' },
  { value: 'READY_TO_SCHEDULE', label: 'Ready to Schedule' },
  { value: 'DENIED', label: 'Denied' },
  { value: 'CANCELLED', label: 'Cancelled' },
];
